<script>
import codigosCIE10 from "./optionsCodigoCIE10";
import EPSs from "./EPSs";
import Swal from "sweetalert2";
// const Swal = require("sweetalert2");

export default {
  mounted() {
    this.formDataBase.codigosCIE10 = codigosCIE10;
    this.formDataBase.EPSs = EPSs;
    console.log("Codigos CIE10:", this.formDataBase.codigosCIE10);
  },
  data() {
    return {
      worker: {
        searching: false,
        imputSearchWorker: null,
        stateErrorWorker: null,
        about: null,
      },
      hasForm: false,
      formDataBase: {
        tipoDeEvento: [
          { value: null, text: "Seleccionar" },
          { value: "EG", text: "EG" },
          { value: "AT", text: "AT" },
          { value: "EL", text: "EL" },
        ],
        codigosCIE10: null,
        EPSs: null,
      },
      newForm: {},
      incapacidades: [],
    };
  },
  methods: {
    // calculoNuevoItem() {
    //   setTimeout(() => {
    //     if (this.newForm.tipoDeEvento == "EG") {
    //       //"Enfermedad General / Incapacidad común"
    //       this.newForm.total = (this.worker.about.salario / 30) * this.diffDate() * this.porcenta3;
    //       this.nuevoItem.total = this.nuevoItem.total.toLocaleString("es");
    //     }
    //     if (this.newForm.tipoDeEvento == "AT") {
    //       // Accidente de Trabajo / Incapacidad Laboral
    //       this.nuevoItem.total = (this.worker.about.salario / 30) * this.diffDate();
    //       this.nuevoItem.total = this.nuevoItem.total.toLocaleString("es");
    //     }
    //     if (this.newForm.tipoDeEvento == "EL") {
    //       // Enfermedad Laboral / Incapacidad Laboral
    //       this.nuevoItem.total = (this.worker.about.salario / 30) * this.diffDate();
    //       this.nuevoItem.total = this.nuevoItem.total.toLocaleString("es");
    //     }
    //     console.log("cal", this.nuevoItem.total);
    //   }, 1000);
    // },
    searchingWorker() {
      this.worker.searching = true;

      this.$store
        .dispatch("get", {
          path: `Persona/GetPersonaCC/${this.worker.imputSearchWorker}`,
        })
        .then((result) => {
          return new Promise((resolve, reject) => {
            result = result.traceId ? null : result;
            if (result) {
              resolve(result);
            } else {
              reject("Trabajador no encontrado");
            }
          });
        })
        .then(async (result) => {
          this.worker.stateErrorWorker = null;
          this.worker.about = result;
          this.initIncapacidades(result.id);
        })
        .catch((error) => {
          this.worker.stateErrorWorker = false;
          this.worker.about = null;
          console.error(error);
        })
        .finally(() => {
          this.worker.searching = false;
        });
    },
    async initIncapacidades(personaId) {
      let result = await this.$store.dispatch("get", {
        path: `RegistroDeIncapacidad/Persona/${personaId}`,
      });
      this.incapacidades = result;
    },

    initNewForm() {
      this.newForm = {
        tipoDeEvento: null,
        fechaInicio: null,
        fechaFinal: null,
        codigoCIE10: null,
        salarioBase: null,
        EPS: null,
        entidadDeSalud: null,
        observaciones: null,
        fechaDePresentacion: null,
      };
    },
    createForm() {
      this.hasForm = true;
      this.initNewForm();
    },
    cancelForm() {
      this.hasForm = false;
    },
    async handleForm() {
      //post
      const model = {
        PersonaId: this.worker.about.id,
        FechaInicio: this.newForm.fechaInicio,
        FechaFinal: this.newForm.fechaFinal,
        FechaDePresentacion: this.newForm.fechaDePresentacion,
        TipoDeEvento: this.newForm.tipoDeEvento,
        CodigoCIE10: this.newForm.codigoCIE10,
        EPS: this.newForm.EPS,
        EntidadDeSalud: this.newForm.entidadDeSalud,
        Observaciones: this.newForm.observaciones,
        Salario: this.worker.about.salario,
      };

      const response = await this.$store.getters.fetchPost({
        path: "RegistroDeIncapacidad",
        data: model,
      });
      const result = await response.json();
      console.log("incapacidad", result);

      // this.$store.dispatch("post", {
      //   path: "RegistroDeIncapacidad",
      //   data: model,
      // });
      if (!result.respuesta) {
        Swal.fire({
          icon: "error",
          title: "Error al registrar incapacidad",
          text: `${result.mensaje}`,
          showConfirmButton: true,
        });
        return;
      } else if (result.respuesta) {
        Swal.fire({
          icon: "success",
          title: "Incapacidad registrada",
          showConfirmButton: false,
          timer: 1500,
        });
        this.initIncapacidades(this.worker.about.id);
        this.initNewForm();
        this.hasForm = false;
      }
    },
    async deleteIncapacidad(Id) {
      let result = await this.$store.dispatch("hl_post",{
        path: `RegistroDeIncapacidad/DeleteIncapacidad/${Id}`,
      });

      console.log("result", result);
      if(result.respuesta === true) {
        Swal.fire({
          icon: "success",
          title: "Incapacidad eliminada",
          showConfirmButton: false,
          timer: 1500,
        });
        this.initIncapacidades(this.worker.about.id);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error al eliminar incapacidad",
          text: "Por favor verifique los datos ingresados",
        });
      }
    },
  },
  computed: {
    diffDate() {
      if (this.newForm.fechaFinal && this.newForm.fechaInicio) {
        const days =
          (new Date(this.newForm.fechaFinal).getTime() -
            new Date(this.newForm.fechaInicio).getTime()) /
          (1000 * 60 * 60 * 24);
        return days + 1;
      }
      return 0;
    },
    descriptionCodigoCIE10() {
      return this.formDataBase.codigosCIE10.find(
        (item) => item.value === this.newForm.codigoCIE10
      );
    },
    salarioBaseDia() {
      return Number.parseFloat(this.newForm.salarioBase / 30).toFixed(2);
    },
  },
  filters: {
    formatDate(value) {
      //formate fecha de la forma 2020-12-31T00:00:00 a 31/12/2020
      return value.split("T")[0].split("-").reverse().join("/");
    },
  },
};
</script>
<template>
  <b-container fluid>
    <b-row>
      <b-col sm="12">
        <card>
          <template v-slot:headerTitle>
            <h4 class="text-white"><b> Registro de incapacidades</b></h4>
          </template>
          <div class="card-body">
            <h4 class="card-title text-white mb-3"><b>Trabajador</b></h4>

            <b-form @submit.prevent="searchingWorker">
              <!-- Busqueda por CC, nombre y apellidos -->
              <b-form-group
                label-for="imputSearchWorker"
                label="Cédula del trabajador"
                invalid-feedback="Trabajador no encontrado"
                description="Cédula de ciudadanía / Nombres y apellidos"
                :state="worker.stateErrorWorker"
              >
                <b-form-input
                  id="imputSearchWorker"
                  v-model="worker.imputSearchWorker"
                  :state="worker.stateErrorWorker"
                  type="text"
                  placeholder="Agregar información de busqueda"
                  required
                ></b-form-input>
              </b-form-group>
              <b-button
                type="submit"
                variant="outline-info"
                :disabled="worker.searching"
                ><i class="fas fa-search"></i> Buscar</b-button
              >
            </b-form>

            <!-- Si existe el trabajador se mostrara la siguiente informacion -->
            <article v-if="worker.about" class="mt-4">
              <h4 class="my-3">Información del trabajador</h4>
              <b-list-group class="info-worker my-3">
                <b-list-group-item class="flex-column align-items-start">
                  <div class="d-flex w-100 justify-content-between">
                    <h4 class="mb-1">
                      {{ worker.about.apellidos }} {{ worker.about.nombres }}
                    </h4>
                  </div>
                  <p>
                    <strong>Cédula de ciudadanía: </strong
                    >{{ worker.about.numeroDocumento }}
                  </p>
                  <p>
                    <strong>Número de incapacidades laborales: </strong
                    >{{ incapacidades.length }}
                  </p>

                  <!-- <p><strong>Fecha: </strong>{{ worker.about.fecha }}</p>
                                <p><strong>Cargo: </strong>{{ worker.about.cargo }}</p>
                                <p><strong>Tipo de trabajador: </strong>{{ worker.about.tipoDeTrabajador }}</p>
                                <p><strong>Área / Obra: </strong>{{ worker.about.area }}</p> -->
                </b-list-group-item>
              </b-list-group>

              <div class="mt-4" v-if="incapacidades.length">
                <h4 class="mb-3">Registro de incapacidades</h4>
                <b-list-group>
                  <b-list-group-item
                    v-for="(incapacidad, index) in incapacidades"
                    :key="incapacidad.id"
                    class="position-relative"
                  >
                    <b-button
                      @click="deleteIncapacidad(incapacidad.id)"
                      class="position-absolute"
                      style="right: 15px"
                    >
                      <i class="fa-solid fa-trash m-0"></i
                    ></b-button>
                    <h4 class="mb-3">incapacidad - {{ index + 1 }}</h4>

                    <p>
                      <strong>Descripción:</strong>
                      {{ incapacidad.tipoDeEvento }}
                    </p>
                    <p>
                      <strong>Fecha inicio:</strong>
                      {{ incapacidad.fechaInicio | formatDate }}
                    </p>
                    <p>
                      <strong>Fecha final:</strong>
                      {{ incapacidad.fechaFinal | formatDate }}
                    </p>
                    <p>
                      <strong>Código CIE10:</strong>
                      {{ incapacidad.codigoCIE10 }}
                    </p>
                    <p><strong>EPS:</strong> {{ incapacidad.eps }}</p>
                    <p>
                      <strong>Entidad de salud:</strong>
                      {{ incapacidad.entidadDeSalud }}
                    </p>
                    <p>
                      <strong>Observaciones:</strong>
                      {{ incapacidad.observaciones }}
                    </p>
                    <p>
                      <strong>Fecha de presentación:</strong>
                      {{ incapacidad.fechaDePresentacion | formatDate }}
                    </p>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </article>
          </div>
        </card>
        <card>
          <template v-slot:headerTitle>
            <h4 class="card-title text-white"><b>Registrar incapacidad</b></h4>
          </template>
          <div class="card-body">
            <div class="d-flex justify-content-center">
              <article class="nueva-incapacidad">
                <vs-button
                  style="width: 250px"
                  success
                  v-show="!hasForm"
                  @click="createForm"
                  :disabled="!worker.about"
                  ><i class="fas fa-plus mr-1"></i> Agregar nueva Incapacidad
                  laboral<template #animate>
                    <i class="fas fa-plus"></i></template
                ></vs-button>
                <vs-button
                  style="width: 250px"
                  danger
                  v-show="hasForm"
                  @click="cancelForm"
                  ><i class="fas fa-xmark pr-1"></i> Cancelar<template #animate>
                    <i class="fas fa-xmark"></i></template
                ></vs-button>
              </article>
            </div>
            <b-form v-if="hasForm" @submit.prevent="handleForm" class="my-4">
              <div class="grid-form">
                <!-- tipo de evento -->
                <b-form-group label-for="tipoDeEvento" label="Tipo de evento">
                  <b-form-select
                    id="tipoDeEvento"
                    v-model="newForm.tipoDeEvento"
                    :options="formDataBase.tipoDeEvento"
                    required
                  ></b-form-select>
                </b-form-group>
                <!-- fecha de entrega -->
                <b-form-group
                  label-for="fechaDePresentacion"
                  label="Fecha de entrega de incapacidad del trabajador"
                >
                  <b-form-input
                    type="date"
                    id="fechaDePresentacion"
                    v-model="newForm.fechaDePresentacion"
                    required
                  ></b-form-input>
                </b-form-group>
                <!-- fecha inicio -->
                <b-form-group
                  label-for="fechaInicio"
                  label="Fecha inicio de incapacidad"
                  class="mb-0"
                >
                  <b-form-input
                    type="date"
                    id="fechaInicio"
                    :max="newForm.fechaFinal"
                    v-model="newForm.fechaInicio"
                    required
                  ></b-form-input>
                </b-form-group>
                <!-- fecha fin -->
                <b-form-group
                  label-for="fechaFinal"
                  label="Fecha final de incapacidad"
                  class="mb-0"
                >
                  <b-form-input
                    type="date"
                    id="fechaFinal"
                    :min="newForm.fechaInicio"
                    v-model="newForm.fechaFinal"
                    required
                  ></b-form-input>
                  <div v-show="diffDate">
                    <p>
                      <strong>Días totales de incapacidad: </strong>
                      {{ diffDate }}
                    </p>
                  </div>
                </b-form-group>

                <!-- codigoCIELO -->
                <b-form-group label-for="codigoCIE10" label="Código CIE 10">
                  <v-select
                    v-model="newForm.codigoCIE10"
                    class="style-chooser"
                    :reduce="(option) => option.value"
                    :options="formDataBase.codigosCIE10"
                    :get-option-label="(option) => option.text"
                    placeholder="-- Seleccionar código CIE 10 --"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!newForm.codigoCIE10"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>

                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        No se encontraron resultados para
                        <em class="text-danger">{{ search }}</em
                        >.
                      </template>
                      <em v-else style="opacity: 0.5"
                        >No hay códigos CIE 10 para mostrar.</em
                      >
                    </template>
                  </v-select>

                  <div v-if="descriptionCodigoCIE10.value">
                    <p>
                      <strong>{{ descriptionCodigoCIE10.value }}: </strong>
                      {{ descriptionCodigoCIE10.text }}
                    </p>
                  </div>
                </b-form-group>
                <!-- EPS -->
                <b-form-group label-for="EPS" label="EPS">
                  <v-select
                    v-model="newForm.EPS"
                    class="style-chooser"
                    :reduce="(option) => option.value"
                    :options="formDataBase.EPSs"
                    :get-option-label="(option) => option.text"
                    placeholder="-- Seleccionar EPS --"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!newForm.EPS"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>

                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        No se encontraron resultados para
                        <em class="text-danger">{{ search }}</em
                        >.
                      </template>
                      <em v-else style="opacity: 0.5"
                        >No hay EPS para mostrar.</em
                      >
                    </template>
                  </v-select>
                </b-form-group>

                <!-- entidad salud -->
                <b-form-group
                  label-for="entidadDeSalud"
                  label="Entidad de salud en donde se generó la incapacidad"
                  description=" Hospital / Centro médico / IPS /"
                >
                  <b-form-input
                    type="text"
                    id="entidadDeSalud"
                    v-model="newForm.entidadDeSalud"
                    required
                  ></b-form-input>
                </b-form-group>
                <!-- observaciones -->
                <b-form-group label-for="observaciones" label="Observaciones">
                  <b-form-textarea
                    id="observaciones"
                    v-model="newForm.observaciones"
                    rows="3"
                    max-rows="6"
                    required
                  ></b-form-textarea>
                </b-form-group>
              </div>
              <div class="w-100 d-flex justify-content-end">
                <b-button type="submit" class="mt-3" variant="outline-success"
                  ><i class="fas fa-check"></i> Registrar</b-button
                >
              </div>
            </b-form>
          </div>
        </card>
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
}
.vs-dropdown-menu {
  z-index: 90 !important;
}

.grid-form {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 columnas */
  gap: 1rem; /* Espaciado entre columnas */
}

@media (max-width: 768px) {
  .grid-form {
    grid-template-columns: 1fr; /* 1 columna en pantallas pequeñas */
  }
}
</style>

<style>
.vs__dropdown-menu {
  max-height: 230px !important;
  overflow-y: auto !important;
}
</style>
